import {
    ROI_OAR_TYPES,
    ROI_POINT_TYPES,
    ROI_TARGET_TYPES,
    RoiInterpretedType,
} from '~/domain/dicom/dicomstructureset';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';

/** Sort group for an interpreted type: targets, OARs, other, points. */
export function getTypeSortGroup(type: RoiInterpretedType): number {
    if (ROI_TARGET_TYPES.includes(type)) {
        return 0;
    }
    if (ROI_OAR_TYPES.includes(type)) {
        return 1;
    }
    if (ROI_POINT_TYPES.includes(type)) {
        return 3;
    }
    return 2;
}

function getRoiSortGroup(roi: RoiReadModel): number {
    const group = getTypeSortGroup(roi.interpretedType);
    if (group === 2 && roi.isPointRoi) {
        return 3;
    }
    return group;
}

/** Visual list order: by sort group, then numeric-aware name compare. */
export function sortRois(a: RoiReadModel, b: RoiReadModel): number {
    const groupDiff = getRoiSortGroup(a) - getRoiSortGroup(b);
    if (groupDiff !== 0) {
        return groupDiff;
    }
    return a.name.localeCompare(b.name, undefined, { numeric: true });
}
